require("dotenv").config() // Add this line to load environment variables

// ** Ripple Button
import "./@core/components/ripple-button"
// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"
// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"
// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss"
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"
// ** i18n
import "./configs/i18n"

// ** Service Worker
import * as serviceWorker from "./serviceWorker"

// ** React Imports
import { Suspense, lazy } from "react"

import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"
// ** ThemeColors Context
import { ThemeContext } from "./utility/context/ThemeColors"
// ** Toast
import { Toaster } from "react-hot-toast"
import { createRoot } from "react-dom/client"
// ** Redux Saga Store
import store from "./store/core/configureStore"
// ** ThemeConfig
import themeConfig from "./configs/themeConfig"

// ** Lazy load app
const LazyApp = lazy(() => import("./App"))

const container = document.getElementById("root")
const root = createRoot(container)

const currentPath = window.location.pathname.split("/")[1]

const basename = currentPath

root.render(
  <BrowserRouter basename={basename}>
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <ThemeContext>
          <LazyApp />
          <Toaster
            position={themeConfig.layout.toastPosition}
            toastOptions={{ className: "react-hot-toast" }}
          />
        </ThemeContext>
      </Suspense>
    </Provider>
  </BrowserRouter>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
